export {ImageSize} from '@web-utilities/images';

export enum Tab {
  UploadedImages,
  ProductImages,
  Url,
}
